module.exports = __webpack_public_path__ + "static/media/message-icon.37210be2.svg";